import { ConferenceCustomImageCrop, ContentVisibility, ImageAttributes } from '@fs/zion-rootstech'

const buildImageDetailFragment = (varPrefix, detail) => {
  return `
    ${ConferenceCustomImageCrop}
    ${ContentVisibility}
    ${ImageAttributes}
    fragment ${detail || varPrefix.charAt(0).toUpperCase() + varPrefix.slice(1)} on ${detail || 'ImageDetail'} {
      alt
      attributes {
        ...ImageAttributes
      }
      contentLocale
      custom(crop: $${varPrefix}_crop, height: $${varPrefix}_height, width: $${varPrefix}_width) {
        ...ConferenceCustomImageCrop
      }
      id
      source
      url
      visibility {
        ...ContentVisibility
      }
      __typename
    }
  `
}
export const ImageDetail = buildImageDetailFragment('imageDetail')
// As of Sep 05 2025; The CoreImageDetail is used ONLY in ImageMutation because it has a different detail related to the Zion image migration
export const CoreImageDetail = buildImageDetailFragment('imageDetail', 'CoreImageDetail')
export const GraphicsImage = buildImageDetailFragment('graphicsImage')
